export class DropdownModel{
  id:number;
  name:string;
}
export class CommonOperationModel {
  deleted         : boolean;
  added           : boolean;
  edited          : boolean;
  none            : boolean;
  id              : number;
}

export class paginationModel 
{
  sortColumn    : string | null = "";
  sortDirection : string | null = "";
  pageNumber    : number = 1;
  page          : number = 1;
  pageSize      : number = 25;
  searchText    : string | null = "";
  getAll        : boolean = false;
}

  export class PaginationPageSizes{
    limitOptions = [
      {
        key: '25',
        value: 25
      },
      {
        key: '50',
        value: 50
      },
      {
        key: '75',
        value: 75
      },
      {
        key: '100',
        value: 100
      },
 
      // {
      //   key: 'all',
      //   value: 0
      // },
    ];
    }
